import { render, staticRenderFns } from "./vActions.vue?vue&type=template&id=38f2325d&scoped=true"
import script from "./vActions.vue?vue&type=script&lang=js"
export * from "./vActions.vue?vue&type=script&lang=js"
import style0 from "./vActions.vue?vue&type=style&index=0&id=38f2325d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2325d",
  null
  
)

export default component.exports